//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    background-color: var(--light-1);
    padding: 12px 16px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    width: ${({ width = "unset" }) => width};
    & svg, & path {
        fill: var(--dark-4);
    }
    @media (max-width: 400px) {
        width: 100%;
    }
`;